import React from 'react';

// Components
import SurfaceItemAvatar from '../SurfaceItemAvatar';
import WpBadge from 'Wpds/components/badge/WpBadge';

// Styles
import '../SurfaceItemDetails.scss';

type Props = {
  surfaceItem;
};

const SalesforceItemDetails = ({ surfaceItem }: Props) => {
  const createdByUserId = surfaceItem.details_panel.created_id;
  const createdByUserName = surfaceItem.details_panel.created_name;
  const assigneeUserId = surfaceItem.details_panel.created_id;
  const assigneeUserName = surfaceItem.details_panel.created_name;

  const amount = surfaceItem.details_panel.amount;

  const getStageBadgeColor = status => {
    return status.startsWith('Closed') ? 'blue' : status.includes('Won') ? 'green' : 'gray';
  };

  const baseClassName = 'SurfaceItemDetails__content';

  return (
    <div className={`${baseClassName}`}>
      {(createdByUserId || createdByUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Created by:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={createdByUserId} displayName={createdByUserName} />
          </div>
        </div>
      )}
      {(assigneeUserId || assigneeUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Opportunity Owner:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={assigneeUserId} displayName={assigneeUserName} />
          </div>
        </div>
      )}
      {amount && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Amount:</div>
          <div className={`${baseClassName}__row__value`}>{`$${amount}`}</div>
        </div>
      )}
      {surfaceItem.status && (
        <>
          <div className={`${baseClassName}__row`}>
            <div className={`${baseClassName}__row__label`}>Status:</div>
            <div className={`${baseClassName}__row__value`}>
              <WpBadge color={getStageBadgeColor(surfaceItem.status)} size="md">
                {surfaceItem.status}
              </WpBadge>
            </div>
          </div>
        </>
      )}
      {surfaceItem.details_panel.incomplete_tasks.length > 0 && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>
            {surfaceItem.details_panel.incomplete_tasks.length + ' '}
            {surfaceItem.details_panel.incomplete_tasks.length > 1 ? <>Incomplete Tasks</> : <>Incomplete Task</>}
          </div>
        </div>
      )}
      {surfaceItem.details_panel.upcoming_events.length > 0 && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>
            {surfaceItem.details_panel.upcoming_events.length + ' '}
            {surfaceItem.details_panel.upcoming_events.length > 1 ? <>Upcoming Events</> : <>Upcoming Event</>}
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesforceItemDetails;
